<template>
    <section class="onboarding select-location">
      <div class="inner">
        <div class="section-body">
          <div class="location-section">
          <form data-abide2 novalidate data-vv-scope="location-form" @submit.prevent="goToWelcome">
            <div class="options">
              <div class="item">
                <button id="gps" class="btn  btn-rounded"
                        :class="{'btn-default': location_type === 'automatic'}"
                        @click="chooseGps"
                        type="button">
                  {{ trans('reg.gps') }}
                </button>
                <p class="text-mute">{{trans('reg.automatic_location')}}</p>
              </div>
              <div class="item">
                <button id="map" class="btn btn-rounded"
                        :class="{'btn-default': location_type === 'manual'}"
                        @click="setlocation_type('manual')"
                        type="button">
                  {{ trans('reg.map') }}
                </button>
                <p class="text-mute">{{trans('reg.manual_location')}}</p>
              </div>
            </div>
            <div class="address-detail location" v-if="addressShow">{{ addressShow }}
              <span class="form-error" :class="{'is-visible': addressError}">
                                {{ addressError }}
                              </span>
            </div>
            <div class="map-section" v-show="mapVisible">
              <div class="address" v-if="mapVisible" :class="{'show': mapVisible}">
                <div class="input-wrapper notranslate">
                  <label>
                    <input
                        v-show="mapVisible"
                        class="form-control dark"
                        type="text"
                        name="address"
                        :placeholder="trans('address')"
                        :data-vv-as="trans('address')"
                        v-model="address"
                        v-validate="'required'"
                        :class="{'is-invalid-input': errors.has('location-form.address')}"
                        @input="handleAddressModification"
                        required
                    />
<!--                    <span class="form-error" v-show="errors.has('location-form.address') || !!addressError" :class="{'is-visible': errors.has('location-form.address') || !!addressError}">
                        {{ errors.first('location-form.address') || addressError }}
                    </span>-->
                  </label>
                </div>
                <div v-show="mapVisible" class="map-box" id="map-box">
                  <Map
                      :lat="lat"
                      :lng="lng"
                      :zoom="15"
                      :styles="mapHeight"
                      :clickable="true"
                      :draggable="true"
                      :dragEnd="handleMapMarkerDrag"/>
                </div>
              </div>
            </div>
            <div class="continue-button" :class="{'map' : mapVisible}" v-show="location_type">
              <button :disabled="addressError || addressShow === trans('reg.location_defining')" type="submit" class="btn btn-rounded btn-primary" id="button-submit">Confirm location</button>
            </div>
          </form>
        </div>
        </div>
      </div>
    </section>
</template>

<script>
import Map from '@buddy/views/widgets/Map.vue';
import _ from "lodash";

export default {
  name: "located",
  mixins: [
    require('@general/lib/mixin').default
  ],
  components: {Map},
  props: ['vars'],
  data() {
    return this.vars;
  },
  computed: {
    mapHeight() {
      if (app.isDesktop) {
        if(this.$resize && this.$mq.below(1024)){
          return 'height: 235px'
        }else{
          return 'height: 335px'
        }
      } else {
        return 'height: 350px'
      }
    },
  },
  methods: {

    decode : function () {
      const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      let input = document.head.querySelector("[name=hash][content]").content;
      let input_secret = document.head.querySelector("[name=hash_secret][content]").content;
      var n = input_secret.slice(-1);
      let index = input_secret.length;
      input = input.substring(0, index-1) + n + input.substring(index);
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      let utftext = output;
      var string = "";
      var i = 0;
      let c = 0;
      let c1 = 0;
      let c2 = 0;
      let c3 = 0;
      while ( i < utftext.length ) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        }
        else if((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i+1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        }
        else {
          c2 = utftext.charCodeAt(i+1);
          c3 = utftext.charCodeAt(i+2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    },
    async submitForm(e) {
      e.preventDefault();
      console.log('Submit form start')
      const token = await this.recaptcha();
      console.log('recaptcha inished')
      this.decode();
      console.log('decode inished')

      let response = await axios.post('/api/register/validate-email', {email: this.email})
      if (response.data.success) {
        let data = {
          handle: this.handle,
          email: this.email,
          password: this.password,
          dob: this.dob,
          headline: this.nickname,
          terms: this.acceptTerms,
          honeypot: this.honeypot.value,
          lang: app.lang,
          lat: this.lat,
          lng: this.lng,
          address: this.address,
          country: this.country,
          country_code: this.country_code,
          location_type: this.location_type,
          locality: this.locality,
          state: this.state,
          recaptcha: token,
          key: this.decode()
        }

        if (this.avatarPhoto) {
          data.photo = this.avatarPhoto
          data.actions = JSON.stringify(this.avatarActions)
        }

        let formData = this.getFormData(data)
        try {
          let response = await axios.post('/api/register/validateAndRegister', formData)
          if (response.status === 200) {
            //after getting data and till reloading page button must be in loading mode

            await auth.login(this.email, this.password)

            if (app.isDesktop) {
              //this.closeRegisterModal()
            }
            //this.goTo('/discover')
            var user = this.$store.getters.userProfile;
            if(user.location_type === 'manual'
                && !user.address && !user.locality){
              //geocode didn't work
              if (app.isDesktop) {
                this.step = 'locality';
              }else{
                this.$router.push('/onboard/location')
              }
            }else{
              if (app.isDesktop) {
                this.step = 'welcome';
              }else{
                window.history.pushState({'id': 1}, '/welcome', '/welcome');
                window.location.reload();
              }
            }

            //window.location.reload();
          }
        } catch (error) {
          let errorFields = error.data.fields
          if (_.intersection(errorFields, ['email', 'password', 'dob']).length !== 0) {
            this.step = 1;
            return false;
          } else if (_.intersection(errorFields, ['photo']).length !== 0) {
            this.step = 2;
            return false;
          } else if (_.intersection(errorFields, ['terms', 'captcha']).length !== 0) {
            this.step = 3;
            return false;
          }

          if (error.status === 422) {
            this.showErrorNotification(error.data.error)
          }
        }
      }else{
        this.errors.add({
          field: 'form5.email',
          msg: response.data.errors.email[0]
        });
      }
    },
    setlocation_type(type) {
        this.location_type = type;

        if (type === 'automatic') {
            this.chooseGps();
        } else if (type === 'manual') {
            this.chooseMap();
        } else {
          return
        }
    },
    handleAddressModification: _.debounce(async function (event){
      let lat, lng;
      if (!event.target.value) {
        return;
      }

      try {
        //update map marker
        this.addressShow = this.trans('reg.location_defining');
        let fullInfo = await this.getLatLngForAddress(this.address, true);
        this.addressShow = this.address;
        ({lat, lng} = fullInfo.point);
        this.lat = parseFloat(lat);
        this.lng = parseFloat(lng);
        this.location_type = 'manual';
        this.locality = fullInfo.locality;
        this.state = fullInfo.state;
        this.country = fullInfo.country;
        this.country_code = fullInfo.country_code;
        let v = this
        setTimeout(function() {
          v.zoom = 15
        }, 500)
        this.addressError = null
      } catch(e) {
        this.addressError = e
      }
    }, 1000),
    async chooseGps() {
      this.mapVisible = false
      this.location_type = 'automatic'
      let lat, lng, address;
      try {
        this.addressShow = this.trans('reg.location_defining');
        ({lat, lng, address} = await this.getCurrentPositionAndAddress(true))
        this.lat = lat
        this.lng = lng
        this.address = address.formattedAddress
        this.locality = address.locality
        this.location_type = 'automatic'
        this.state = address.state
        this.country = address.country
        this.country_code = address.country_code
        this.addressShow = address.formattedAddress;
        this.addressError = null
      } catch (e) {
        this.addressShow = ' ';
        this.addressError = this.trans('fail_auto_choose_manual_location')
      }
    },
    chooseMap() {
        this.location_type = 'manual';
        this.mapVisible = true;
        if(this.addressError){
          this.addressShow = this.trans('reg.location_defining');
          this.addressError = '';
          if(this.address){
            this.addressShow = this.address;
          }
        }
    },
    async handleMapMarkerDrag(event) {
      let newLat, newLng;

      if (this.mapProviderIsGmap) {
        newLat = event.latLng.lat();
        newLng = event.latLng.lng();
      } else {
        newLat = event.target.getLatLng().lat;
        newLng = event.target.getLatLng().lng;
      }

      try {
        let fullInfo = await this.getAddressForLatLng(newLat, newLng, true);
        this.lat = newLat;
        this.lng = newLng;
        this.location_type = 'manual';
        this.address = fullInfo.formattedAddress;
        this.locality = fullInfo.locality;
        this.state = fullInfo.state;
        this.country = fullInfo.country;
        this.country_code = fullInfo.country_code;
        this.addressError = null
        this.addressShow = fullInfo.formattedAddress;
      } catch(e) {
        this.addressError = e
      }
    },
    async recaptcha() {
      await this.$recaptchaLoaded()

      return await this.$recaptcha('login')
    },
    async goToWelcome(e) {
        this.showLoadingButton('#button-submit')
        let validate = await this.$validator.validateAll('location-form')
        if (validate) {
          await this.submitForm(e);
          if(this.isMobile){
            window.history.pushState({'id':1},'/welcome','/welcome');
            window.location.reload();
          }else{
            this.step = 'welcome';
          }
        }
        this.restoreLoadingButton('#button-submit')
    }
  },
  mounted(){
  }
}
</script>

<style scoped>

</style>